import React from "react";
import PropTypes from "prop-types";

import { Headline } from "../../Atoms/Headline";
import { Subheadline } from "../../../../arrow/components/Atoms/Subheadline";
import { AuthorWithTime } from "../../Atoms/AuthorWithTimestamp";
import { getTextColor, rgbToHex } from "../../../utils/utils";

import "./storycardContent.m.css";

export const StorycardContent = ({
  story,
  children,
  theme,
  border,
  isHorizontalMobile,
  headerLevel,
  borderColor,
  config,
  separator,
  showSubHeadLine = false,
  showMultipleAuthor,
  showAuthorContent,
  sectionSlug,
  isYTPageHeadline = false,
  showTimeStamp = true
}) => {
  const textColor = getTextColor(theme);
  const borderOptions = ["full"];
  const SectionTagborderColor = rgbToHex(borderColor);
  const borderTemplate = borderOptions.includes(border) ? `border-${border}` : "";
  const horizontalCard = isHorizontalMobile ? "horizontal-content-wrapper" : "";
  return (
    <div
      className="arr--content-wrapper"
      data-test-id="story-card-content"
      styleName={`wrapper ${borderTemplate} ${horizontalCard}`}
      style={{ backgroundColor: theme, color: textColor }}
    >
      {children || (
        <DefaultStoryCardContent
          story={story}
          headerLevel={headerLevel}
          isHorizontalMobile={isHorizontalMobile}
          borderColor={SectionTagborderColor}
          config={config}
          showSubHeadLine={showSubHeadLine}
          separator={separator}
          showMultipleAuthor={showMultipleAuthor}
          showAuthorContent={showAuthorContent}
          sectionSlug={sectionSlug}
          isYTPageHeadline={isYTPageHeadline}
          showTimeStamp={showTimeStamp}
        />
      )}
    </div>
  );
};

const DefaultStoryCardContent = ({
  story,
  headerLevel,
  config = {},
  showSubHeadLine = false,
  separator,
  showMultipleAuthor,
  showAuthorContent,
  sectionSlug,
  isYTPageHeadline = false,
  showTimeStamp = true,
}) => {
  const { localizationConfig = {} } = config;

  return (
    <div>
      <Headline
        story={story}
        headerLevel={headerLevel}
        premiumStoryIconConfig={config}
        sectionSlug={sectionSlug}
        isYTPageHeadline={isYTPageHeadline}
      />
      <AuthorWithTime
        config={localizationConfig}
        story={story}
        separator={separator}
        showMultipleAuthor={showMultipleAuthor}
        showAuthorContent={showAuthorContent}
        showTimeStamp={showTimeStamp}
      />
      {showSubHeadLine && <Subheadline story={story} headerLevel={headerLevel} premiumStoryIconConfig={config} />}
    </div>
  );
};

DefaultStoryCardContent.propTypes = {
  story: PropTypes.object.isRequired,
  border: PropTypes.string,
  theme: PropTypes.string,
  isHorizontalMobile: PropTypes.bool,
  headerLevel: PropTypes.string,
  borderColor: PropTypes.string,
  config: PropTypes.object,
  showSubHeadLine: PropTypes.bool,
  showMultipleAuthor: PropTypes.bool,
  isYTPageHeadline: PropTypes.bool,
};

StorycardContent.propTypes = {
  story: PropTypes.object.isRequired,
  children: PropTypes.node,
  theme: PropTypes.string,
  border: PropTypes.string,
  isHorizontalMobile: PropTypes.bool,
  headerLevel: PropTypes.string,
  borderColor: PropTypes.string,
  config: PropTypes.object,
  showSubHeadLine: PropTypes.bool,
  showMultipleAuthor: PropTypes.bool,
  isYTPageHeadline: PropTypes.bool,
};

StorycardContent.defaultProps = {
  isYTPageHeadline: false,
};
